/* 🤖 this file was generated by svg-to-ts*/
export const icoLockClosed: {
  name: 'lock-closed';
  data: string;
} = {
  name: 'lock-closed',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2a5 5 0 015 5v3h1a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2h1V7a5 5 0 015-5zm6 10H6v8h12v-8zm-6 2a2 2 0 110 4 2 2 0 010-4zm0-10a3 3 0 00-3 3v3h6V7a3 3 0 00-3-3z" fill="#909090"/></svg>`
};
